var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('LoginForm',{attrs:{"loginErr":_vm.loginErr,"loginErrMessage":_vm.loginErrMessage,"joinOrg":false,"redirect":_vm.redirectUrl}}),_vm._v(" "),_c('router-link',{staticClass:"to-register-link",attrs:{"to":"register"}},[_c('span',{staticClass:"smaller"},[_vm._v("First time here? Register")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e289179","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 